// src/Components/Pages/FAQs.js
import React from "react";
import "../Privacy&Policy/Privacy&Policy.css";

const FAQs = () => {
  return (
    <div className="policy-container">
      <h1>FAQs – CUTTECH SOLUTIONS</h1>

      <h2>1. What is CUTTECH SOLUTIONS?</h2>
      <p>
        CUTTECH SOLUTIONS is an Indian cutting tool manufacturing brand under SAGAR GROUP OF INDUSTRIES and SIMPLE MECHANICAL SOLUTIONS, focused on delivering high-performance CNC cutting tools for industries like Automotive, Aerospace, Defense, and General Engineering.
      </p>

      <h2>2. What does CUTTECH SOLUTIONS manufacture?</h2>
      <ul>
        <li>Gear Hob Cutters</li>
        <li>Threading Tools</li>
        <li>Grooving and Parting Tools</li>
        <li>Milling Cutters</li>
        <li>Drilling and Boring Tools</li>
        <li>Customized Special Tools</li>
      </ul>

      <h2>3. Who is the founder of CUTTECH SOLUTIONS?</h2>
      <p>Keerthisagar A. M. is the founder of CUTTECH SOLUTIONS.</p>

      <h2>4. Who is Keerthisagar A. M.?</h2>
      <p>
        Keerthisagar A. M. is an Indian Mechanical Engineer and Industrialist, the visionary behind Simple Mechanical Solutions, CUTTECH Solutions, and AskMechanics.
      </p>

      <h2>5. What is the qualification of Keerthisagar A. M.?</h2>
      <ul>
        <li>Diploma in Mechanical Engineering (Sanjay Memorial Polytechnic, Sagar, Karnataka)</li>
        <li>B.E. in Mechanical Engineering (CMR Institute of Technology, Bangalore)</li>
        <li>Certified Metal Cutting Engineer from Sandvik Coromant</li>
      </ul>

      <h2>6. Where is the manufacturing unit of CUTTECH SOLUTIONS?</h2>
      <p>The manufacturing unit is located in Sunkadakatte, Bangalore, Karnataka, India.</p>

      <h2>7. Does CUTTECH SOLUTIONS have dealers?</h2>
      <p>Yes, CUTTECH SOLUTIONS operates through a growing network of authorized dealers across India who also visit industries for technical support and sales.</p>

      <h2>8. What makes CUTTECH different from foreign brands?</h2>
      <ul>
        <li>Competitive pricing</li>
        <li>Customization for Indian industry needs</li>
        <li>Indigenous manufacturing</li>
        <li>Fast service and support</li>
        <li>Reducing import dependency</li>
      </ul>

      <h2>9. Is CUTTECH SOLUTIONS providing Special Pricing for the Indian Defense Sector?</h2>
      <p>Yes, CUTTECH SOLUTIONS offers Special Pricing exclusively for the Indian Defense Sector.</p>

      <h2>10. What is Special Pricing for the Indian Defense Sector?</h2>
      <p>
        Special Pricing is not only about cost reduction — it includes Techno-Commercial Support. CUTTECH’s expert team works closely with defense customers to support:
      </p>
      <ul>
        <li>Research and Development</li>
        <li>New Product Development</li>
        <li>Application Engineering</li>
        <li>Process Optimization</li>
      </ul>
      <p>All while ensuring competitive pricing and maximum value.</p>

      <h2>11. Why Special Pricing for the Indian Defense Sector?</h2>
      <p>
        CUTTECH SOLUTIONS is committed to the Make in India and Aatmanirbhar Bharat missions. Special Pricing helps defense organizations by:
      </p>
      <ul>
        <li>Reducing dependency on imported cutting tools</li>
        <li>Accelerating innovation through local technical collaboration</li>
        <li>Supporting indigenous defense manufacturing with precision-engineered solutions</li>
      </ul>
    </div>
  );
};

export default FAQs;
